"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var iterate = function (iterator, state, path) {
    if (path === void 0) { path = immutable_1.List(); }
    iterator.forEach(function (value, key) {
        var _path = path.push(key);
        if (value === null)
            state.deleteIn(_path);
        if (immutable_1.Map.isMap(value))
            return iterate(value, state, _path);
        return state.setIn(_path, value);
    });
};
exports.default = (function (prev, next) { return prev.withMutations(function (s) { return iterate(next, s); }); });
//# sourceMappingURL=deepMerge.js.map